import React from "react";
import { useTranslation } from "react-i18next";
import Card from "./Card/Card";
import styles from "./GridComponent.module.scss";

interface GridItem {
  icon?: string;
  title: string;
  description?: string;
  translateTitle?: boolean;
  translateDescription?: boolean;
}

interface GridComponentProps {
  title?: string;
  items: GridItem[];
  bottomTitle?: string;
  bottomText?: string;
  translateTitle?: boolean;
  translateBottomTitle?: boolean;
  translateBottomText?: boolean;
}

const GridComponent: React.FC<GridComponentProps> = ({
  title,
  items,
  bottomTitle,
  bottomText,
  translateTitle = false,
  translateBottomTitle = false,
  translateBottomText = false,
}) => {
  const { t } = useTranslation("common");

  const displayTitle = title && translateTitle ? t(title) : title;
  const displayBottomTitle =
    bottomTitle && translateBottomTitle ? t(bottomTitle) : bottomTitle;
  const displayBottomText =
    bottomText && translateBottomText ? t(bottomText) : bottomText;

  return (
    <div className="container">
      <div
        className={`sectionContainer sectionContainerWhite bigSection ${
          !displayTitle ? styles.noTitle : ""
        }`}
      >
        {displayTitle && (
          <div className="sideP64 titleCont">
            <div className="titleBlock w100">
              <h2
                dangerouslySetInnerHTML={{
                  __html: displayTitle,
                }}
              />
            </div>
          </div>
        )}
        <div
          className={`sectionBlock ${!displayTitle ? styles.noTitleBlock : ""}`}
        >
          <div className={styles.grid}>
            {items.map((item, index) => (
              <Card
                key={index}
                icon={item.icon}
                title={item.title}
                description={item.description}
                translateTitle={item.translateTitle}
                translateDescription={item.translateDescription}
              />
            ))}
          </div>
        </div>
        {(displayBottomTitle || displayBottomText) && (
          <div className={`sideP64 ${styles.bottomBlock}`}>
            {displayBottomTitle && (
              <h3 className={styles.bottomTitle}>{displayBottomTitle}</h3>
            )}
            {displayBottomText && (
              <p className={styles.bottomText}>{displayBottomText}</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default GridComponent;
